<template>
  <v-row class="ma-0">
        <v-col md="4" sm="6" class="px-2" v-if="liga=='https://suministros.uno/'">
            <v-card class="py-4 px-4 elevation-0" v-if="loader">
                <v-progress-circular
                    indeterminate
                    color="primary"
                    class="ma-0"
                ></v-progress-circular>
            </v-card>
            <v-card class="py-2 px-4 elevation-0" v-else>
                <v-icon x-small color="#47bdc6" class="mr-1">mdi-circle</v-icon> 
                <span style="font-size:12px;"><strong>Kilos</strong></span>
                <br/><span>{{cards.total_inventory}} kgs</span>
            </v-card>
        </v-col>
        <v-col md="4" sm="6" class="px-2">
            <v-card class="py-4 px-4 elevation-0" v-if="loader">
                <v-progress-circular
                    indeterminate
                    color="primary"
                    class="ma-0"
                ></v-progress-circular>
            </v-card>
            <v-card class="py-2 px-4 elevation-0" v-else>
                <v-icon x-small color="#ff6d00" class="mr-1">mdi-circle</v-icon> 
                <span style="font-size:12px;"><strong>Costo</strong></span>
                <br/><span>{{(cards.total_inventory_cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
            </v-card>
        </v-col>
        <v-col md="4" sm="6" class="px-2">
            <v-card class="py-4 px-4 elevation-0" v-if="loader">
                <v-progress-circular
                    indeterminate
                    color="primary"
                    class="ma-0"
                ></v-progress-circular>
            </v-card>
            <v-card class="py-2 px-4 elevation-0" v-else>
                <v-icon x-small color="#4385f3" class="mr-1">mdi-circle</v-icon> 
                <span style="font-size:12px;"><strong>Costo Promedio</strong></span>
                <br/><span>{{(cards.average_cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    methods:{
        fetchData(){
            this.$store.dispatch('inventory_cost/getCards')
        }
    },
    mounted() {
        this.fetchData()
    },
    computed: {
        cards(){
            return this.$store.state.inventory_cost.cards
        },
        loader(){
            return this.$store.state.inventory_cost.cards_loader
        },
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE 
        },
    },
}
</script>

<style>

</style>